import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "map-filter__options" }
const _hoisted_2 = { class: "flex-column" }
const _hoisted_3 = ["data-tour"]
const _hoisted_4 = { class: "map-filter__data-vis-title mb-8" }
const _hoisted_5 = { class: "m-0" }
const _hoisted_6 = { class: "map-filter__data-vis-info mb-16" }
const _hoisted_7 = { class: "map-filter__data-vis-btns" }
const _hoisted_8 = { class: "map-filter__drawer-body" }
const _hoisted_9 = { class: "flex-row items-center mb-24" }
const _hoisted_10 = { class: "m-0 ml-8 map-filter__drawer-title" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "mt-24"
}
const _hoisted_13 = {
  key: 2,
  class: "mt-24"
}
const _hoisted_14 = {
  key: 3,
  class: "mt-24"
}
const _hoisted_15 = {
  key: 4,
  class: "mt-24"
}
const _hoisted_16 = {
  key: 5,
  class: "mt-24"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_c_icon_left_right = _resolveComponent("c-icon-left-right")!
  const _component_c_info_row = _resolveComponent("c-info-row")!
  const _component_c_button = _resolveComponent("c-button")!
  const _component_c_button_radio = _resolveComponent("c-button-radio")!
  const _component_c_grid = _resolveComponent("c-grid")!
  const _component_c_drawer = _resolveComponent("c-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_c_info_row, {
          "data-tour": _ctx.TourSelector.PERIOD,
          title: _ctx.$t('filters.author.title'),
          "title-info": _ctx.authorSelectedLabel,
          active: _ctx.isVisibleDict[_ctx.FilterName.AUTHOR],
          "click-action": () => _ctx.toggleVisibilityFilter(_ctx.FilterName.AUTHOR)
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_c_icon_left_right, {
              "is-left": _ctx.isVisibleDict[_ctx.FilterName.AUTHOR]
            }, null, 8, ["is-left"])
          ]),
          _: 1
        }, 8, ["data-tour", "title", "title-info", "active", "click-action"]),
        (_ctx.dataTypeList?.length)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "p-24",
              "data-tour": _ctx.TourSelector.OBSERVATION
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t('filters.dataType.title')), 1)
              ]),
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('filters.dataType.info')), 1),
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataTypeList, (item) => {
                  return (_openBlock(), _createBlock(_component_c_button, {
                    key: item,
                    class: "map-filter__data-btn",
                    name: _ctx.FilterName.DATA,
                    type: _ctx.ButtonType.FILTER,
                    "is-active": _ctx.dataTypeSelected === item,
                    onClick: ($event: any) => (_ctx.selectFilter(_ctx.FilterName.DATA, item))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.getDataTypeLabel(item)), 1)
                    ]),
                    _: 2
                  }, 1032, ["name", "type", "is-active", "onClick"]))
                }), 128))
              ])
            ], 8, _hoisted_3))
          : _createCommentVNode("", true),
        (_ctx.variables?.length)
          ? (_openBlock(), _createBlock(_component_c_info_row, {
              key: 1,
              "data-tour": _ctx.TourSelector.VARIABLES,
              title: _ctx.$t('filters.variable.title'),
              "title-info": _ctx.getSelectedVariableLabel(_ctx.variablesSelected),
              active: _ctx.isVisibleDict[_ctx.FilterName.VARIABLE],
              "has-divider-start": true,
              "click-action": () => _ctx.toggleVisibilityFilter(_ctx.FilterName.VARIABLE)
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_c_icon_left_right, {
                  "is-left": _ctx.isVisibleDict[_ctx.FilterName.VARIABLE],
                  disabled: _ctx.variablesIsDisabled
                }, null, 8, ["is-left", "disabled"])
              ]),
              _: 1
            }, 8, ["data-tour", "title", "title-info", "active", "click-action"]))
          : _createCommentVNode("", true),
        (_ctx.basePeriodList?.length)
          ? (_openBlock(), _createBlock(_component_c_info_row, {
              key: 2,
              "data-tour": _ctx.TourSelector.PERIOD,
              title: _ctx.$t('filters.period.title'),
              "title-info": _ctx.getSelectedBasePeriodLabel(_ctx.basePeriodSelected),
              active: _ctx.isVisibleDict[_ctx.FilterName.PERIOD],
              "click-action": () => _ctx.toggleVisibilityFilter(_ctx.FilterName.PERIOD)
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_c_icon_left_right, {
                  "is-left": _ctx.isVisibleDict[_ctx.FilterName.PERIOD],
                  disabled: _ctx.periodIsDisabled
                }, null, 8, ["is-left", "disabled"])
              ]),
              _: 1
            }, 8, ["data-tour", "title", "title-info", "active", "click-action"]))
          : _createCommentVNode("", true),
        (_ctx.gwlList?.length)
          ? (_openBlock(), _createBlock(_component_c_info_row, {
              key: 3,
              "data-tour": _ctx.TourSelector.PERIOD,
              title: _ctx.$t('filters.gwl.title'),
              "title-info": _ctx.getSelectedGWLLabel(_ctx.gwlSelected),
              active: _ctx.isVisibleDict[_ctx.FilterName.GWL],
              "click-action": () => _ctx.toggleVisibilityFilter(_ctx.FilterName.GWL)
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_c_icon_left_right, {
                  "is-left": _ctx.isVisibleDict[_ctx.FilterName.GWL],
                  disabled: !_ctx.gwlList?.length
                }, null, 8, ["is-left", "disabled"])
              ]),
              _: 1
            }, 8, ["data-tour", "title", "title-info", "active", "click-action"]))
          : _createCommentVNode("", true),
        (_ctx.scenarioList?.length)
          ? (_openBlock(), _createBlock(_component_c_info_row, {
              key: 4,
              "data-tour": _ctx.TourSelector.SEASON,
              title: _ctx.$t('filters.scenario.title'),
              "title-info": _ctx.getSelectedScenarioLabel(_ctx.scenarioSelected),
              active: _ctx.isVisibleDict[_ctx.FilterName.SCENARIO],
              "click-action": () => _ctx.toggleVisibilityFilter(_ctx.FilterName.SCENARIO)
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_c_icon_left_right, {
                  "is-left": _ctx.isVisibleDict[_ctx.FilterName.SCENARIO],
                  disabled: _ctx.seasonIsDisabled
                }, null, 8, ["is-left", "disabled"])
              ]),
              _: 1
            }, 8, ["data-tour", "title", "title-info", "active", "click-action"]))
          : _createCommentVNode("", true),
        (_ctx.seasonList?.length)
          ? (_openBlock(), _createBlock(_component_c_info_row, {
              key: 5,
              "data-tour": _ctx.TourSelector.SEASON,
              title: _ctx.$t('filters.season.title'),
              "title-info": _ctx.getSelectedSeasonLabel(_ctx.seasonSelected),
              active: _ctx.isVisibleDict[_ctx.FilterName.SEASON],
              "click-action": () => _ctx.toggleVisibilityFilter(_ctx.FilterName.SEASON)
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_c_icon_left_right, {
                  "is-left": _ctx.isVisibleDict[_ctx.FilterName.SEASON],
                  disabled: _ctx.seasonIsDisabled
                }, null, 8, ["is-left", "disabled"])
              ]),
              _: 1
            }, 8, ["data-tour", "title", "title-info", "active", "click-action"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_c_drawer, {
      show: _ctx.showDrawer,
      offset: {
			top: '0',
			left: '360px', // based on filters width
		}
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_c_icon_left_right, {
                "is-left": _ctx.showDrawer,
                onClick: _ctx.closeFilterDrawer
              }, null, 8, ["is-left", "onClick"]),
              _createElementVNode("h5", _hoisted_10, _toDisplayString(_ctx.activeFilterTitle), 1)
            ]),
            (_ctx.isVisibleDict[_ctx.FilterName.AUTHOR])
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_c_grid, {
                    list: _ctx.authors.map((item) => ({ key: item.slug, name: item.name })),
                    "item-margin-bottom": _ctx.gridMargin,
                    "grid-style": _ctx.gridStyle
                  }, {
                    item: _withCtx(({ item }) => [
                      _createVNode(_component_c_button_radio, {
                        name: _ctx.FilterName.AUTHOR,
                        value: item.key,
                        label: item.name,
                        checked: item.key === _ctx.authorSelected,
                        onCheck: ($event: any) => (_ctx.selectAuthor({ slug: item.key, name: item.name }))
                      }, null, 8, ["name", "value", "label", "checked", "onCheck"])
                    ]),
                    _: 1
                  }, 8, ["list", "item-margin-bottom", "grid-style"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isVisibleDict[_ctx.FilterName.VARIABLE])
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_component_c_grid, {
                    list: 
									_ctx.variables.map((item) => ({ key: item, name: _ctx.getSelectedVariableLabel(item) }))
								,
                    "item-margin-bottom": _ctx.gridMargin,
                    "grid-style": _ctx.gridStyle
                  }, {
                    item: _withCtx(({ item }) => [
                      _createVNode(_component_c_button_radio, {
                        name: _ctx.FilterName.VARIABLE,
                        value: item.key,
                        label: item.name,
                        checked: item.key === _ctx.variablesSelected,
                        onCheck: ($event: any) => (_ctx.selectFilter(_ctx.FilterName.VARIABLE, item))
                      }, null, 8, ["name", "value", "label", "checked", "onCheck"])
                    ]),
                    _: 1
                  }, 8, ["list", "item-margin-bottom", "grid-style"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isVisibleDict[_ctx.FilterName.PERIOD])
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(_component_c_grid, {
                    list: 
									_ctx.basePeriodList.map((item) => ({
										key: item,
										name: _ctx.getSelectedBasePeriodLabel(item),
									}))
								,
                    "grid-style": _ctx.gridStyle,
                    "item-margin-bottom": _ctx.gridMargin
                  }, {
                    item: _withCtx(({ item }) => [
                      _createVNode(_component_c_button_radio, {
                        name: _ctx.FilterName.PERIOD,
                        value: item.key,
                        label: item.name,
                        checked: item.key === _ctx.basePeriodSelected,
                        onCheck: ($event: any) => (_ctx.selectFilter(_ctx.FilterName.PERIOD, item))
                      }, null, 8, ["name", "value", "label", "checked", "onCheck"])
                    ]),
                    _: 1
                  }, 8, ["list", "grid-style", "item-margin-bottom"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isVisibleDict[_ctx.FilterName.SCENARIO])
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(_component_c_grid, {
                    list: 
									_ctx.scenarioList.map((item) => ({ key: item, name: _ctx.getSelectedScenarioLabel(item) }))
								,
                    "grid-style": _ctx.gridStyle,
                    "item-margin-bottom": _ctx.gridMargin
                  }, {
                    item: _withCtx(({ item }) => [
                      _createVNode(_component_c_button_radio, {
                        name: _ctx.FilterName.SCENARIO,
                        value: item.key,
                        label: item.name,
                        checked: item.key === _ctx.scenarioSelected,
                        onCheck: ($event: any) => (_ctx.selectFilter(_ctx.FilterName.SCENARIO, item))
                      }, null, 8, ["name", "value", "label", "checked", "onCheck"])
                    ]),
                    _: 1
                  }, 8, ["list", "grid-style", "item-margin-bottom"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isVisibleDict[_ctx.FilterName.GWL])
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(_component_c_grid, {
                    list: _ctx.gwlList.map((item) => ({ key: item, name: _ctx.getSelectedGWLLabel(item) })),
                    "grid-style": _ctx.gridStyle,
                    "item-margin-bottom": _ctx.gridMargin
                  }, {
                    item: _withCtx(({ item }) => [
                      _createVNode(_component_c_button_radio, {
                        name: _ctx.FilterName.GWL,
                        value: item.key,
                        label: item.name,
                        checked: item.key === _ctx.gwlSelected,
                        onCheck: ($event: any) => (_ctx.selectFilter(_ctx.FilterName.GWL, item))
                      }, null, 8, ["name", "value", "label", "checked", "onCheck"])
                    ]),
                    _: 1
                  }, 8, ["list", "grid-style", "item-margin-bottom"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isVisibleDict[_ctx.FilterName.SEASON])
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createVNode(_component_c_grid, {
                    list: 
									_ctx.seasonList.map((item) => ({ key: item, name: _ctx.getSelectedSeasonLabel(item) }))
								,
                    "grid-style": _ctx.gridStyle,
                    "item-margin-bottom": _ctx.gridMargin
                  }, {
                    item: _withCtx(({ item }) => [
                      _createVNode(_component_c_button_radio, {
                        name: _ctx.FilterName.SEASON,
                        label: item.name,
                        value: item.key,
                        checked: item.key === _ctx.seasonSelected,
                        onCheck: ($event: any) => (_ctx.selectFilter(_ctx.FilterName.SEASON, item.key))
                      }, null, 8, ["name", "label", "value", "checked", "onCheck"])
                    ]),
                    _: 1
                  }, 8, ["list", "grid-style", "item-margin-bottom"])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}